import React from 'react'
import { Link } from 'react-router-dom';
import '../layouts/UserManagementNavbar.scss';
import customer from '../assets/images/customer.svg';
import projectMaster from '../assets/images/projectMaster.svg';
import companyMaster from '../assets/images/companyMaster.svg';
import distributorMaster from '../assets/images/distributorMaster.svg';
import productMaster from '../assets/images/productMaster.svg';

const UserManagementNavbar = () => {
    return (
        <div className='container-fluid user-management-nav-bar'>
            <div className='row ml-4 mr-4 mt-5'>
                <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                                    <div className='d-flex'>
                                        <div className='card card1 m-3'>
                                            <Link to="/user-master">
                                                <div className='card-body'>
                                                    <img src={customer}></img>
                                                    <h5 className='mt-3'>User master</h5>
                                                </div>
                                                <div className='card-footer'>
                                                    <h6>User master : <span>1240</span></h6>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className='card card2 m-3'>
                                            <Link to="/role-management">

                                                <div className='card-body'>
                                                    <img src={projectMaster}></img>
                                                    <h5 className='mt-3'>Role management</h5>
                                                </div>
                                                <div className='card-footer'>
                                                    <h6>Total projects : <span>1240</span></h6>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserManagementNavbar